// @flow

import { useValidation } from './use-validation';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';

export function useSubmitError(): ?PlaceOrderErrorPayload {
  const validation = useValidation();
  return validation.submitError;
}
